const IMG_TYPES = {
    'THUMB': 10,
    'DSN': 20
}

module.exports = {
    IMG_TYPES
};
